<template>
  <div>
    <s-pageheader title="包装管理" />
    <ak-model-filter-card model="allPack" @search="search" @reset="reset" />
    <ak-model-card model="allPack" :perPage="30" :page.sync="page" :filters="filters" />
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader/PageHeader'
export default {
  components: {
    's-pageheader': PageHeader,
  },
  data () {
    return {
      filters: {},
      page: 1
    }
  },
  methods: {
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = filters // 修改modelTable的查询条件会自动触发刷新
    },
    reset () {
      this.page = 1
      this.filters = {}
    }
  }
}
</script>

<style>

</style>
